<template>
    <span class="icon" v-bind="$attrs" :aria-hidden="false" aria-label="Light" role="img" @click="$emit('click', $event)">
        <svg :width="size" :height="size" viewBox="0 0 20 20">
            <path d="M10.0007 9.99999C10.459 9.99999 10.8515 9.83666 11.1782 9.50999C11.5043 9.18388 11.6673 8.79166 11.6673 8.33332C11.6673 7.87499 11.5043 7.48249 11.1782 7.15582C10.8515 6.82971 10.459 6.66666 10.0007 6.66666C9.54232 6.66666 9.1501 6.82971 8.82398 7.15582C8.49732 7.48249 8.33398 7.87499 8.33398 8.33332C8.33398 8.79166 8.49732 9.18388 8.82398 9.50999C9.1501 9.83666 9.54232 9.99999 10.0007 9.99999ZM10.0007 16.125C11.6951 14.5694 12.952 13.1561 13.7715 11.885C14.5909 10.6144 15.0007 9.4861 15.0007 8.49999C15.0007 6.9861 14.5179 5.74638 13.5523 4.78082C12.5873 3.81582 11.4034 3.33332 10.0007 3.33332C8.59787 3.33332 7.41371 3.81582 6.44815 4.78082C5.48315 5.74638 5.00065 6.9861 5.00065 8.49999C5.00065 9.4861 5.41037 10.6144 6.22982 11.885C7.04926 13.1561 8.30621 14.5694 10.0007 16.125ZM10.0007 18.3333C7.76454 16.4305 6.09454 14.663 4.99065 13.0308C3.88621 11.3992 3.33398 9.88888 3.33398 8.49999C3.33398 6.41666 4.00426 4.75693 5.34482 3.52082C6.68482 2.28471 8.23676 1.66666 10.0007 1.66666C11.7645 1.66666 13.3165 2.28471 14.6565 3.52082C15.997 4.75693 16.6673 6.41666 16.6673 8.49999C16.6673 9.88888 16.1154 11.3992 15.0115 13.0308C13.907 14.663 12.2368 16.4305 10.0007 18.3333Z" :fill="fillColor" />
        </svg>
    </span>
</template>

<script lang="ts" setup>
interface Props {
    fillColor?: string;
    size?: number;
}
defineEmits(['click'])
withDefaults(defineProps<Props>(), {
    fillColor: 'currentColor',
    size: 16
})

const id = useId()
</script>